import { all } from 'redux-saga/effects';
import { authSagas } from '@/modules/auth';
import { subscriptionSagas } from '@/modules/subscription';
import { toastSaga } from './sagas/toast-saga';

export function* rootSaga() {
  yield all([authSagas(), subscriptionSagas(), toastSaga()]);
}
